import script from "./CtaDiagnostico.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaDiagnostico.vue?vue&type=script&setup=true&lang=js"

import "./CtaDiagnostico.vue?vue&type=style&index=0&id=f8c04512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c04512"]])

export default __exports__